import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';

import { getAllRoutes } from '../utils/routes';
import { useInitializeWorkflowNavigation } from '../hook/useInitializeWorkflowNavigation';
import { requestProposalSelectors } from '../store';
import RequestProposal from './RequestProposal/RequestProposal';
import QuoteRequested from './QuoteRequested/QuoteRequested';
import ViewQuote from './ViewQuote/ViewQuote';
import AcceptedDeal from './AcceptedDeal/AcceptedDeal';
import DealProposal from './DealProposal/DealProposal';
import RequestChangesModal from './RequestChangesModal/RequestChangesModal';

const Root: React.FC<{
    baseRoute: string;
}> = ({ baseRoute }) => {
    const { requestQuote, quoteRequested, viewQuote, acceptedDeal, dealProposal } = getAllRoutes(baseRoute);
    const { search } = useLocation();
    const isDealProposalEnabled = useSelector(requestProposalSelectors.additionalSelectors.isMultiScenarioOfferEnabled);

    const workflowRoute = useInitializeWorkflowNavigation(requestQuote);

    return (
        <div data-testid="deal-summary-activity-container">
            <Switch>
                <Route path={requestQuote} component={RequestProposal} />
                <Route path={quoteRequested} component={QuoteRequested} />
                {isDealProposalEnabled && <Route path={dealProposal} component={DealProposal} />}
                {isDealProposalEnabled && <Redirect from={viewQuote} to={{ pathname: dealProposal, search }} />}
                {isDealProposalEnabled && <Redirect from={acceptedDeal} to={{ pathname: dealProposal, search }} />}
                <Route path={viewQuote} component={ViewQuote} />
                <Route path={acceptedDeal} component={AcceptedDeal} />
                <Redirect to={`${workflowRoute ?? requestQuote}${search}`} />
            </Switch>
            <RequestChangesModal />
        </div>
    );
};

export default Root;
